module.exports = __webpack_public_path__ + "img/293-kingsway-logo.02510e24.png";